<template>
    <div>
        <Header />
        <div class="desktop">
            <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
        </div>
        <div class="mobile">
            <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText"
                :isTextinput="false" />
        </div>
        <BodyLinks />
        <b-container class=" mt-4">
            <Activation />
            <b-row class="desktop">
                <b-col cols="3">
                    <RecipeSidebar class="mt-5" created='active' />
                </b-col>
                <b-col cols="9">
                    <div v-if="loading">
                        <content-loader :speed="2" :height="400" :width="700">
                            <rect x="4" y="8" rx="3" ry="3" width="7" height="288" />
                            <rect x="6" y="289" rx="3" ry="3" width="669" height="8" />
                            <rect x="670" y="9" rx="3" ry="3" width="6" height="285" />
                            <rect x="55" y="42" rx="16" ry="16" width="274" height="216" />
                            <rect x="412" y="113" rx="3" ry="3" width="102" height="7" />
                            <rect x="402" y="91" rx="3" ry="3" width="178" height="6" />
                            <rect x="405" y="139" rx="3" ry="3" width="178" height="6" />
                            <rect x="416" y="162" rx="3" ry="3" width="102" height="7" />
                            <rect x="405" y="189" rx="3" ry="3" width="178" height="6" />
                            <rect x="5" y="8" rx="3" ry="3" width="669" height="7" />
                            <rect x="406" y="223" rx="14" ry="14" width="72" height="32" />
                            <rect x="505" y="224" rx="14" ry="14" width="72" height="32" />
                            <rect x="376" y="41" rx="3" ry="3" width="231" height="29" />
                        </content-loader>
                    </div>
                    <div v-if="recipes.length > 0">
                        <p class="mb-4">{{page}} of {{rows}} Recipes</p>
                        <b-row class="mb-3 eventcard" v-for="(food, index) in recipes" :key="index">
                            <b-col class="firstcol col-md-6"
                                v-bind:style='{ backgroundImage: "url(" + food.images + ")", }'>

                            </b-col>
                            <b-col class="firstborder-right">
                                <div class="font14 mt-3 text-capitalize">
                                    <router-link :to="{ name: 'recipe-details', params: {id: food.food_id} }">
                                        {{food.name}}
                                    </router-link>
                                </div>
                                <div class="font12">
                                    <b-form-rating readonly show-value inline size="sm" v-model="food.average_ratings">
                                    </b-form-rating>
                                </div>
                                <p class="font10">
                                    {{food.storyline | truncate(100)}} </p>
                                <p class="culture-primary font12">
                                    <span>Price:</span> <span class="font-weight-600">{{food.fee_type === 'paid' ?
                                        food.amount: 'Free'}} {{food.fee_type === 'paid' ? food.currency: ''}}</span>
                                </p>
                                <p v-if="food.event" class="culture-primary font12">
                                    <span>Attached Event:</span> <span
                                        class="font-weight-600">{{food.event.name}}</span>
                                </p>
                                <div class="justify-content-around" v-if="currentUser.user_id === food.cook.user_id">
                                    <router-link class="font12"
                                        :to="{ name: 'edit-recipe', params: {id: food.food_id }}">
                                        <b-icon font-scale="0.99" icon="pencil"></b-icon> Edit
                                    </router-link>
                                    <span @click="deleteFood(food.food_id)" class="btn font12">
                                        <b-icon font-scale="0.99" icon="trash"></b-icon> Delete
                                    </span>
                                    <span @click="userEvents(food)" class="btn font12">
                                        <b-icon font-scale="0.99" icon="calendar-2"></b-icon>
                                        {{food.event ? 'Detach Event':'Attach Event'}}

                                    </span>
                                    <span>
                                        <b-icon v-if="sloading" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon>
                                    </span>

                                </div>

                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="recipes.length == 0 && !loading">
                        No recipe created yet, be the first to <router-link class="culture-primary"
                            to="/listings/recipes/create"> create </router-link> one
                    </div>
                    <div v-if="recipes.length >0">
                        <b-pagination v-model="page" :total-rows="rows" @change="getRecepies" :per-page="no_per_page">
                        </b-pagination>
                    </div>
                </b-col>
            </b-row>
            <div class="mobile">
                <b-row>
                    <b-col cols="3">
                        <RecipeSidebar menuId="slidmenu" @handleOpen="openMenu" @handleHide="hideSidemenu" class="mt-5"
                            created='active' />
                    </b-col>
                    <b-col cols="9">
                        <b-row class="head-box mb-5">
                            <b-col cols="12" class="">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon font-scale="0.99" icon="bucket"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" v-model="name" placeholder="Recipe Name "></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" class="">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon font-scale="0.99" icon="tag"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" v-model="ingredient" placeholder="ingredients ">
                                    </b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" class="btn-box ">
                                <button @click="getRecepies" class="d-inline-flex btn btn-warning btn-culture">
                                    <b-icon font-scale="0.99" icon="search"></b-icon> Search
                                </button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <p class="mb-4">{{page}} of {{rows}} recipes</p>
                <div class="mb-3 p-3 eventcard" v-for="(food, index) in recipes" :key="index">
                    <div class="row ml-0">
                        <img :src="food.images" alt="" style="width:40%;height:100px">
                        <div class="ml-3">
                            <div class="font14 mt-3">
                                {{food.name}}

                            </div>
                            <div class="font12">
                                <b-form-rating readonly show-value inline size="sm" v-model="food.average_ratings">
                                </b-form-rating>
                            </div>
                        </div>

                    </div>
                    <p class="font10 mt-3">
                        {{food.storyline | truncate(100)}}
                    </p>
                    <p class="culture-primary font12">
                        <span>Price:</span> <span class="font-weight-600">{{food.fee_type === 'paid' ?
                            food.amount: 'Free'}} {{food.fee_type === 'paid' ? food.currency: ''}}</span>
                    </p>
                    <p v-if="food.event" class="culture-primary font12">
                        <span>Attached Event:</span> <span class="font-weight-600">{{food.event.name}}</span>
                    </p>
                    <div class="justify-content-around" v-if="currentUser.user_id === food.cook.user_id">
                        <router-link class="font12" :to="{ name: 'edit-recipe', params: {id: food.food_id }}">
                            <b-icon font-scale="0.99" icon="pencil"></b-icon> Edit
                        </router-link>
                        <span @click="deleteFood(food.food_id)" class="btn font12">
                            <b-icon font-scale="0.99" icon="trash"></b-icon> Delete
                        </span>
                        <span @click="userEvents(food)" class="btn font12">
                            <b-icon font-scale="0.99" icon="calendar-2"></b-icon>
                            {{food.event ? 'Detach Event':'Attach Event'}}
                        </span>
                    </div>
                </div>
                <div v-if="recipes.length == 0 && !loading">
                    No recipe created yet, be the first to <router-link class="culture-primary"
                        to="/listings/recipes/create"> create </router-link> one
                </div>
                <div v-if="recipes.length >0">
                    <b-pagination v-model="page" :total-rows="rows" @change="getRecepies" :per-page="no_per_page">
                    </b-pagination>
                </div>
            </div>
            <b-modal id="event-modal" centered title="Attach Event" hide-footer>
                <form @submit.prevent="attachEvent">
                    <b-form-group class="mb-3" label-for="event">
                        <select required class="mb-3 custom-select" v-model="event_id">
                            <option value="" selected disabled>Select event</option>
                            <option v-for="(event, index) in createdEvents" :key="index" :value="event.event_id">
                                {{ event.name }}
                            </option>
                        </select>
                    </b-form-group>
                    <p class="font13">Create a new event instead? 
                        <router-link target="_blank" class="culture-primary" to="/listings/events/create">click here</router-link>
                    </p>
                    <b-form-group class="mb-2" label-for="event">
                        <button class="btn btn-warning btn-below font12">{{modalbtnText}}</button>
                    </b-form-group>
                </form>

            </b-modal>

        </b-container>
        <Footer />
    </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import RecipeSidebar from "@/components/RecipeSidebar.vue";
import {
    ContentLoader
} from "vue-content-loader";

import axios from "axios";
import {
    getBaseUrl
} from "../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'created-recipe-listings',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        ContentLoader,
        RecipeSidebar,
        Footer,

    },
    data: function () {
        return {
            headerText: "CREATED RECIPES",
            subText: "See all recipes you created",
            fadedText: "recipes",
            food: '',
            ingredient: '',
            name: '',
            rating: 0,
            recipes: [],
            no_per_page: 10,
            page: 1,
            loading: true,
            createdEvents: [],
            event_id: '',
            recipe_id: '',
            modalbtnText: 'Attach Event',
            sloading:false
        }
    },
    mounted() {
        this.getRecepies();
    },
    computed: {
        rows() {
            return this.recipes.length
        },
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        },
        currentUser: function () {
            return this.$store.getters.currentUser;
        }
    },
    methods: {
        openMenu() {
            this.$root.$refs.A.openMenu('slidmenu')
        },
        hideSidemenu() {
            this.$root.$refs.A.hideSidemenu('slidmenu')
        },
        gotoRecipe() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: "/listings/food/create",
                    },
                });
            } else {
                this.$router.push({
                    name: "create-foodlisting",
                });
            }
        },
        async getRecepies(page = 1) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/foodlistings?page=${page}`,
                    params: {
                        no_per_page: this.no_per_page,
                        name: this.name,
                        ingredient: this.ingredient,
                        cook_id: this.currentUser.user_id
                    },
                    method: "GET",
                })
                this.loading = false
                this.recipes = resp.data.data
            } catch (error) {
                this.loading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        searchFood() {
            if (this.name === "" && this.ingredient === "") {
                this.$root.$refs.A.makeToast('danger', 'Enter search keywords')
                this.getRecepies();
            } else {
                this.recipes = this.recipes.filter(i => i.name.toLowerCase().includes(this.name.toLowerCase()) || i.ingredients.toLowerCase().includes(this.ingredient.toLowerCase()));

            }

        },
        async deleteFood(food_id) {
            if (confirm("Do you really want to delete this recipe?")) {
                try {
                    await axios({
                        url: `${base_url}/api/v2/foodlistings/${food_id}`,
                        method: "DELETE",
                    })
                    this.getRecepies();
                } catch (error) {
                    this.$root.$refs.A.makeToast('danger', error.response.data.message)
                }
            }
        },
        async rateRecipe(food) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/flratings`,
                    data: {
                        food_listing_id: food.food_id,
                        rating: this.rating
                    },
                    method: "POST",
                })
                this.$bvModal.hide('rate-food')
                this.getRecepies();
                this.$root.$refs.A.makeToast('success', resp.data.message)

            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        },
        async handleAttachEvent(food, page) {
            this.$bvModal.show("event-modal")
            this.recipe_id = food.food_id;
            const hostid = this.currentUser.user_id
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/events`,
                    params: {
                        host_id: hostid,
                        page: page,
                        no_per_page: this.no_per_page
                    },
                    method: "GET",
                })
                this.createdEvents = resp.data.data;
            } catch (error) {
                this.loading = false;
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async userEvents(food, page = 1) {
            if (!food.event) {
                this.handleAttachEvent(food, page)
            } else {
                const eventId = food.event.event_id;
                const recipeId = food.food_id
                this.detachEvent(recipeId, eventId)
            }

        },
        async attachEvent() {
            const data = {
                recipe_linkage: 'yes',
                recipe_id: this.recipe_id
            }
            this.modalbtnText = 'Attaching...'
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/events/${this.event_id}?_method=PUT`,
                    data: data,
                    method: "POST",
                })
                this.modalbtnText = 'Attach Event'
                this.$root.$refs.A.makeToast('success', resp.data.message)
                this.$bvModal.hide("event-modal")
                this.getRecepies();
            } catch (error) {
                this.modalbtnText = 'Attach Event'
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async detachEvent(recipeId, eventId) {
            this.sloading = true
            const data = {
                recipe_linkage: 'no',
                recipe_id: recipeId
            }
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/events/${eventId}?_method=PUT`,
                    data: data,
                    method: "POST",
                })
                this.sloading = false
                this.getRecepies();
                this.$root.$refs.A.makeToast('success', resp.data.message)
            } catch (error) {
                this.sloading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.eventcard {
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    border: none !important;
    background: #FCFCFC;
    height: 240px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 280px;
    }
}

.eventcard .firstcol {
    padding-left: 0 !important;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 16px 0 0 16px;
    max-height: 240px
}

.button-list {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 13px;
    padding-right: 45px;
    width: 100%;
}

.btn-culture {
    padding: 10px 60px !important;
    line-height: 1.9 !important;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        line-height: 0.9 !important;
    }
}

.b-icon.bi {
    margin-bottom: 2px !important
}

.bi-search {
    margin-right: 1rem;
}

.btn-box {
    margin: 14px 0
}

.list-group {
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
}

.list-group-item {
    padding: 0.7rem 1rem !important;
    text-align: left;
    border: none !important;
    margin: 10px 0 !important;
}

.list-group-item.active {
    background: rgba(86, 92, 99, 0.05) !important;
    color: rgba(86, 92, 99, 1) !important;
    text-align: center !important
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #F6F7F7;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0;
    }
}

.eventcard:hover {
    border: 1px solid #F7B131 !important;
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.inner-header-box:hover {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box:hover .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.flex {
    display: flex;
    justify-content: space-between;
}

.btn-below {
    padding: 7px 11px !important
}

.form-control-sm {
    padding: 0.25rem 0 !important;
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 8px) !important;

}

.culture-primary span {
    color: #565C63 !important
}

.slide-menu {
    position: absolute;
    z-index: 99;
    background: #fff;
    margin-left: calc(-40em + 10px);
    width: 328%;
    top: -2px;
    padding-left: 16px;
    transition: all 0.5s ease-in-out;
}

span.del {
    cursor: pointer;
}

.rating-title {
    font-size: 32px;
    font-weight: bold
}

a {
    color: #565C63
}
</style>
